<template>
  <div>
    <label for="searchquery" class="h4">{{ textLabel }}</label>
    <input
      id="searchquery"
      type="text"
      :placeholder="textPlaceholder"
      class="form-control w-100 rounded shadow-sm"
      @keyup="setFilter"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash/debounce";

export default {
  props: {
    textPlaceholder: {
      type: String,
      required: true,
    },
    textLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      productNameFilter: "lists/getProductNameFilter",
    }),
  },
  methods: {
    ...mapActions({ setProductNameFilter: "lists/setProductNameFilter" }),
    setFilter: debounce(function(e) {
      this.setProductNameFilter(e.target.value);
    }, 500),
  },
};
</script>
